import get from 'lodash/get'
import { formatDate } from '../../utils/dates'

const fieldsPartial = `
  id
  code
  name
`

const filterTypes = {}

const getParentResource = () => null

const getName = () => 'expenseCategory'

const getLabel = () => 'Expense categories'

const getRecordById = (state, id) => get(state, `admin.resources.expenseCategory.data.${id}`, null)

const getLabelForRecord = record => {
  if (!record) {
    return ''
  }
  return `${formatDate(record.name)}`
}

export default {
  fieldsPartial,
  getParentResource,
  getName,
  getLabel,
  getRecordById,
  getLabelForRecord,
  filterTypes,
}
